export enum MetadataDescLabel {
  DOC_NAME_KEY = 'DocName',
  DOC_TITLE_KEY = 'DocTitle',
  DOC_CONTENT_TYPE_KEY = 'DocContentType',
  DOC_CREATE_DATE_KEY = 'DocCreateDate',
  DOC_TIME_TO_LIVE_KEY = 'DocTtlInDay',
  DOC_SIZE = 'size',
}
